// @flow
import { isEmpty, set } from 'lodash';
import  store from '../core/store/store';

export async function restService({ api, third_party, method, params }) {
  const state = store.getState();
  const token = state.auth && state.auth.agent && state.auth.agent.accessToken;
  const headers = {};

  let path;

  if (process.env.REACT_APP_ENV !== 'prod') {
    path = `${process.env.REACT_APP_DEVELOPMENT_API}${api}`;
  } else {
    path = `${process.env.REACT_APP_PRODUCTION_API}${api}`;
  }

  if (third_party) {
    path = api;
  }

  set(headers, 'Accept', 'application/json');
  set(headers, 'Content-Type', 'application/json');
  if (token) {
    set(headers, 'Authorization', `Bearer ${token}`);
  }

  const reqBody = {
    method,
    headers,
    credentials: 'include',
  };

  if (!isEmpty(params)) {
    reqBody.body = JSON.stringify(params);
  }
  return fetch(path, reqBody)
    .then(response => {
      return response.text().then(text => {
        return text ? { status: response.status, data: JSON.parse(text) } : { status: response.status };
      });
    })
    .catch(error => {
      return {
        result: 'error',
        error,
      };
    });
}
